import React, { Fragment } from 'react';
import ModuleComponent from '../module';
import * as env from './../../environment';
import { number_format, get_box_color_document } from './../utils/utils'
import { FormRow, ButtonRefresh } from "./../../generalStyles/mixin";

const { API_URL_INJECTOR } = env[process.env.NODE_ENV];

export class documentProcess extends React.Component {

  state = { summaryBoxes: [], authToken: localStorage.getItem("token"), hovered: false }

  _fetchBoxes() {
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.state.authToken}`
      }
    };

    fetch(`${API_URL_INJECTOR}/injector/summary`)
      .then(result => result.json())
      .then(response => {
        var totalElement = response.summary.splice(this._getTotalIndex(response.summary), 1);
        response.summary.push(totalElement[0]);

        this.setState({ summaryBoxes: response.summary, authToken: '' })
      });
  }

  _getTotalIndex(summaryArray) {
    let indice = 0;
    summaryArray.map((orderBox, index) => {
      const { title } = orderBox;
      if (title === 'Total') {
        indice = index
      }
    })

    return indice;
  }

  componentDidMount() {
    this._fetchBoxes()
  }

  handleRefresh() {
    this.setState({ summaryBoxes: [], hovered: false });
    this._fetchBoxes();
  }

  render() {

    if (this.state.summaryBoxes.length > 0) {

      return (
        <Fragment>
          <FormRow style={{ marginTop: "-70px", padding: "10px 10px 0px 0px" }}>
            <ButtonRefresh
              src="/images/refresh.png"
              style={{ transform: `${this.state.hovered ? 'rotate(280deg)' : 'rotate(80deg)'}` }}
              onMouseOver={() => this.setState({ hovered: true })}
              onMouseOut={() => this.setState({ hovered: false })}
              onClick={this.handleRefresh.bind(this)} />
          </FormRow>

          {this.state.summaryBoxes.map(box => {
            const { title, quantity, amount } = box;
            return (

              <ModuleComponent
                title={title}
                number={quantity}
                textNumber=''
                textAmount=''
                style={get_box_color_document(title)}
              />

            )
          })}
        </Fragment>
      )
    } else {
      return <p className="text-center">Cargando...</p>
    }
  }

}

export default documentProcess;
